<template>
    <div 
        id="modal__backdrop"
        class="modal__backdrop"
        @mousedown="mousedown($event)"
        @mouseup="mouseup($event)"
    >
        <div 
            class="modal__container" 
            style="overflow: auto;"
        >
            <slot name="modalBody"></slot>
        </div>
    </div>
</template>

<script>
export default {
    /**
     * данные компонента
     * @property {string} mousedownElementId - id элемент dom дерева над которым свершилось событие mousedown
     * @property {string} mouseupElementId - id элемент dom дерева над которым свершилось событие mouseup
     */
    data: () => ({
        mousedownElementId: "",
        mouseupElementId: ""
    }),
    methods: {
        /**
         * событие mousedown
         * @param {object} event - объект события
         */
        mousedown(event) {
            const { id } = event.toElement;
            this.mousedownElementId = id;
        },
        /**
         * событие mouseup
         * @param {object} event - объект события
         */
        mouseup(event) {
            const { id } = event.toElement;
            this.mouseupElementId = id;

            this.close();
        },
        /**
         * событие закрытия модельного окна
         */
        close() {
            if (this.mousedownElementId === "modal__backdrop" && this.mouseupElementId === "modal__backdrop") {
                this.$emit("close");
            }
            this.mousedownElementId = "";
            this.mouseupElementId = "";
        }
    }
}
</script>

<style lang="scss" scoped>
    .modal__backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(34, 34, 34, 0.9);
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: auto;
        z-index: 2999999999;
    };
    .modal__container {
        background-color: white;
        position: relative;
    };
</style>